/**
 * Lifecycle of a bulk-assign-counterparty Temporal job, exposed to the frontend
 * via a workflow query (no Task row is persisted for this).
 */
export enum BulkAssignCounterpartyJobStatus {
	INITIATED = 'INITIATED',
	PREPARING = 'PREPARING',
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
}

export interface BulkAssignCounterpartyJobStatusState {
	status: BulkAssignCounterpartyJobStatus;
	/** User who initiated the job — used to authorize the status query. */
	actorId: string;
	/** Total instances matching the selection at job start. */
	total: number;
	/** Instances attempted so far. */
	processed: number;
	/** Successful ASSIGN actions applied (result rows, not instances). */
	assigned: number;
	/** Successful UNASSIGN actions applied (result rows, not instances). */
	unassigned: number;
	/** Instances attempted with no successful change (ineligible/no-op, e.g. fully signed). */
	skipped: number;
	errors: string[];
}

/** Name of the Temporal workflow query exposing BulkAssignCounterpartyJobStatusState. */
export const BULK_ASSIGN_COUNTERPARTY_JOB_STATUS_QUERY = 'getJobStatus';
